import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import IconClose from '../../vectors/IconClose'
import media, { LargeScreenUp } from '../../utils/style'
import Image from '../Image'
import cookieByName from '../../utils/cookie-by-name'

import {
  NewsStripEl,
  NewsStripItems,
  NewsStripItem,
  NewsStripItemContent,
  NewsStripHeadline,
  NewsStripDescription,
  NewsStripButton,
  NewsStripDismiss
} from '../NewsStrip/elements'

function getBackground(theme, background) {
  if (background === 'dark' || !background) {
    return theme.colors.grey
  }

  if (background === 'light') {
    return '#EEF4F9'
  }

  return background
}

function getForeground(theme, background) {
  if (background === 'dark' || !background) {
    return theme.colors.white
  }

  if (background === 'light') {
    return theme.colors.grey_mid
  }

  return theme.colors.white
}

const HypeStripEl = styled(({ theme, background, ...rest }) => (
  <NewsStripEl {...rest} />
))`
  background-color: ${(props) => getBackground(props.theme, props.background)};
  color: ${(props) => getForeground(props.theme, props.background)};
`

const HypeStripDismiss = styled(({ theme, background, ...rest }) => (
  <NewsStripDismiss {...rest} />
))`
  svg path {
    fill: ${(props) => getForeground(props.theme, props.background)};
  }
`

const HypeStripButton = styled(({ theme, background, ...rest }) => (
  <NewsStripButton {...rest} />
))`
  ${media.SmallishScreenUp`
    position: relative;
    color: ${(props) =>
      getForeground(props.theme, props.background)} !important;
    border: 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 1px solid ${(props) =>
        getForeground(props.theme, props.background)};
      opacity: 0.7;
      border-radius: 3px;
      transition: all, 0.1s ease-in-out;
    }

    &:hover::before {
      opacity: 1;
    }
  `}
`

const HypeStripImageLink = styled.a`
  display: block;
  height: 48px;
  flex: 0 0 auto;
  max-width: 100px;
`

class EventHypeStrip extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      collapsed: true
    }

    this.dismiss = this.dismiss.bind(this)
    this.setCookie = this.setCookie.bind(this)
  }

  getCookie() {
    const eventCookie = cookieByName('EventHypeDismissed')

    try {
      const cookie = JSON.parse(eventCookie)
      return Array.isArray(cookie) ? cookie : []
    } catch (e) {
      return []
    }
  }

  UNSAFE_componentWillReceiveProps({ _id }) {
    const eventsDismissed = this.getCookie()
    let isEventDismissed = false

    if (eventsDismissed && eventsDismissed.length > 0) {
      isEventDismissed = eventsDismissed.find((eventId) => eventId === _id)
    }

    this.setState({
      collapsed: isEventDismissed
    })
  }

  setCookie() {
    const eventsDismissed = this.getCookie()
    eventsDismissed.push(this.props._id)
    document.cookie = `EventHypeDismissed=${JSON.stringify(eventsDismissed)}`
  }

  dismiss() {
    this.setState({ collapsed: true })
    this.setCookie()
  }

  formatDate(date) {
    return moment(date).format('Do MMMM')
  }

  render() {
    return (
      <span id="hype-strip-placeholder">
        {!this.state.collapsed && this.props._id && (
          <HypeStripEl background={this.props.hypeStripColour}>
            <HypeStripDismiss
              background={this.props.hypeStripColour}
              onClick={this.dismiss}
            >
              <IconClose />
            </HypeStripDismiss>
            <NewsStripItems>
              <NewsStripItem active>
                <LargeScreenUp>
                  {this.props.images && this.props.images.length > 0 && (
                    <HypeStripImageLink href={this.props.locationUrl}>
                      <Image
                        mode="cover"
                        width={100}
                        height={48}
                        imgWidth={100}
                        resource={this.props.images[0]}
                        alt=""
                      />
                    </HypeStripImageLink>
                  )}
                </LargeScreenUp>
                <NewsStripItemContent>
                  <NewsStripHeadline>{this.props.headline}</NewsStripHeadline>
                  {this.props.eventStartDate && this.props.eventEndDate && (
                    <NewsStripDescription>
                      ({this.formatDate(this.props.eventStartDate)} -{' '}
                      {this.formatDate(this.props.eventEndDate)})
                    </NewsStripDescription>
                  )}
                </NewsStripItemContent>
                <HypeStripButton
                  background={this.props.hypeStripColour}
                  onClick={this.setCookie}
                  href={this.props.locationUrl}
                >
                  Find out more
                </HypeStripButton>
              </NewsStripItem>
            </NewsStripItems>
          </HypeStripEl>
        )}
      </span>
    )
  }
}

export default EventHypeStrip
